module.exports = __webpack_public_path__ + "static/img/5.a7e3e85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/vivo/5.png
// module id = pwOt
// module chunks = 0